import { useState, RefObject, useLayoutEffect } from "react"

export function useFullScreen(
  containerRef: RefObject<HTMLDivElement>,
  videoRef: RefObject<HTMLVideoElement>,
) {
  const [isFullScreen, setIsFullScreen] = useState(false)
  const [scrollAmt, setScrollAmt] = useState(0)

  function handleFullScreen() {
    if (!containerRef.current) {
      return
    }
    setScrollAmt(window.scrollY)
    containerRef.current.onfullscreenchange = () => {
      setIsFullScreen(Boolean(document.fullscreenElement === containerRef.current))
    }
    const el = containerRef.current as any
    if (el.requestFullscreen) {
      el.requestFullscreen()
    } else if (el.mozRequestFullScreen) {
      el.mozRequestFullScreen()
      setIsFullScreen(true)
    } else if (el.webkitRequestFullScreen) {
      el.webkitRequestFullScreen()
      setIsFullScreen(true)
    } else if (el.webkitEnterFullScreen) {
      el.webkitEnterFullScreen()
      setIsFullScreen(true)
    } else if (el.msRequestFullscreen) {
      el.msRequestFullscreen()
      setIsFullScreen(true)
    } else {
      // IOS doesnt support full screen on non video elements
      // @ts-ignore
      videoRef.current.webkitEnterFullscreen()
      console.log("blah")
    }
  }

  function handleExitFullScreen() {
    setIsFullScreen(false)

    const docEl = document as any
    if (docEl.exitFullscreen) {
      docEl.exitFullscreen()
    } else if (docEl.mozCancelFullScreen) {
      docEl.mozCancelFullScreen()
    } else if (docEl.webkitExitFullscreen) {
      docEl.webkitExitFullscreen()
    } else if (docEl.msExitFullscreen) {
      docEl.msExitFullscreen()
    }
    containerRef.current!.onfullscreenchange = null
  }

  useLayoutEffect(() => {
    document.onfullscreenchange = () => {
      if (!isFullScreen) {
        window.scrollTo(0, scrollAmt)
      }
    }
    return () => {
      document.onfullscreenchange = null
    }
  })

  return { isFullScreen, handleFullScreen, handleExitFullScreen }
}
